export default "__VITE_ASSET__DMJQgPsb__"